module.exports = __webpack_public_path__ + "images/emoji/rage.d147ff4339ebd11cdec3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rage.png
// module id = OKiF
// module chunks = 1